import { createIcon } from '@chakra-ui/icons';

export const WhatsappIcon = createIcon({
  displayName: 'WhatsappIcon',
  viewBox: '0 0 32 32',
  path: [
    <g key="1" clipPath="url(#shareWhatsapp)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9953 0C7.17534 0 1.8196e-05 7.17667 1.8196e-05 16C-0.00508156 19.3701 1.06192 22.6544 3.04669 25.378L1.05336 31.3227L7.2027 29.3573C9.81193 31.0869 12.8743 32.0063 16.0047 32C24.8247 32 32 24.8227 32 16C32 7.17733 24.8254 0 16.0047 0H15.9953ZM11.5287 8.12667C11.218 7.384 10.9834 7.356 10.5134 7.33667C10.3349 7.32537 10.1562 7.31936 9.97735 7.31866C9.36535 7.31866 8.72601 7.49734 8.34068 7.89201C7.87068 8.37201 6.70469 9.49066 6.70469 11.786C6.70469 14.0813 8.37802 16.3013 8.60402 16.612C8.83936 16.922 11.8674 21.7 16.5687 23.6473C20.2454 25.1713 21.3367 25.03 22.1734 24.8513C23.396 24.588 24.9287 23.6847 25.314 22.594C25.7 21.5027 25.7 20.5713 25.5873 20.374C25.474 20.1767 25.1634 20.064 24.694 19.8287C24.2234 19.5933 21.938 18.4647 21.5053 18.314C21.0827 18.154 20.6787 18.2107 20.3587 18.662C19.9074 19.2927 19.4653 19.932 19.108 20.3173C18.826 20.6187 18.3647 20.6567 17.9793 20.496C17.462 20.28 16.014 19.772 14.2274 18.1827C12.8447 16.95 11.9047 15.4173 11.632 14.956C11.3587 14.486 11.604 14.2133 11.82 13.9593C12.0553 13.6673 12.2807 13.4607 12.516 13.188C12.7507 12.9147 12.8827 12.774 13.0333 12.4547C13.1933 12.144 13.08 11.824 12.9667 11.588C12.8547 11.3533 11.914 9.05801 11.5287 8.12734V8.12667Z"
        fill="#67C15E"
      />
    </g>,
    <defs key="2">
      <clipPath id="shareWhatsapp">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>,
  ],
});
